import React, { Component } from "react";
import "../style/About.css";

export default class About extends Component {
  render() {
    return (
      <div id="about">
        <section className="about-title">/about me</section>
        <section className="about-description">
          <p>
            I'm currently a Computer Science student at the{" "}
            <element className="name">University of British Columbia</element>.
            I'm an aspiring software engineer, and am always looking to further
            my knowledge in the realm of full-stack development. Currently
            seeking internships!
          </p>
        </section>
      </div>
    );
  }
}
